import { render, staticRenderFns } from "./wind.vue?vue&type=template&id=471735e8"
import script from "./wind.vue?vue&type=script&lang=js"
export * from "./wind.vue?vue&type=script&lang=js"
import style0 from "./wind.vue?vue&type=style&index=0&id=471735e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports